module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/n6WGXL/tc-custom/9781398468528.jpg?1738955550180",
      "alt": "This image is the cover for the book You Are My Possible"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("You Are My Possible\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Hayat is a dreamer, a fantasist, a fiercely bold and mesmerizingly beautiful girl who carries her heart on her sleeve. She is unable to reveal her wild, erotic and rebellious side to anyone, therefore, tucked away in the darkness of every night, she plays out her fantasies in her dreams with her dream man – Ra’ees. He is her soul mate, lover, confidante and ultimately, her forbidden love. Hayat meets Ra’ees at a wedding and their union unfolds one dream at a time as their relationship surrenders to erotic, sexual encounters that take place at different locations and in risky situations. Hayat finds herself falling in love with Ra’ees but his reservations and their combined fate eventually takes on a fatal turn…")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sahara Rai\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sahara Rai, born and raised in the East End of London, moved to Essex at an early age where she first tasted freedom and discovered a voice. Sahara grew up fascinated with writing love stories, which lead to her excelling in English Literature. She has always been an avid writer and speaker of bold, taboo subjects and finally, after years of discouragement and lost opportunity, she reveals her most prized possession: You Are My Possible. Sahara Rai began writing her collection of short stories when the world was facing the global COVID-19 pandemic and the opportunity to reflect was in abundance. Sahara Rai is currently working full time, juggling a professional career and writing in her spare time. She is currently working on her next book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0